import React, { Component, Fragment } from 'react'
import { Redirect } from 'react-router-dom'
import Headbar from '@app/components/shared/Headbar'
// import ProfileSubheader from '@app/components/shared/ProfileSubheader'
import getDisplayName from 'react-display-name'
import { UserContext } from '@app/context/user-context'
import { definePublicAbilities, authorize } from '@app/ability'
import { afterSignInPathFor } from '@app/helpers/sessionHelper'
import classnames from 'classnames'

class PublicLayout extends Component {
  static contextType = UserContext

  get isLoggedIn() { return this.context.isLoggedIn }

  render() {
    const Component = this.props.component
    const { route, global, layout } = this.props

    const session = this.context
    const ability = definePublicAbilities(session)

    if ( !authorize(ability, Component) ) {
      return <Redirect to={ afterSignInPathFor(session.user) } />
    }

    return layout ? (
      <div
        className={
          classnames('layout', 'w-flex-layout', 'layout--public')
        }>
        <div className="w-flex-layout__top">
          {
            this.isLoggedIn ? (
              <Fragment>
                <Headbar
                  user={session.user.transform}
                  global={global}
                  route={route}
                />
                {/*<ProfileSubheader event={global.event} />*/}
              </Fragment>
            ) : (
              <Headbar global={global} route={route} />
            )
          }
        </div>
        <div className="w-flex-layout__center">
          <Component route={route} global={global} />
        </div>
        <div className="w-flex-layout__bottom" />
      </div>
    ) : (
      <Component route={route} global={global} />
    )
  }
}

PublicLayout.defaultProps = {
  layout: true
};

export default PublicLayout
